import React from "react";
import PropTypes from "prop-types";

const Button = ({
    label,
    varient,
    disabled,
    fullWidth,
    color,
    onClick
}) => {
    let buttonClass = '';

    if (varient === 'contained') {
        if (disabled) {
            buttonClass = "bg-gray-500 text-white";
        } else {
            buttonClass = `${color === 'primary' ? 'bg-primary text-white' : ''}`;
        }
    } else {
        if (disabled) {
            buttonClass = 'bg-white text-gray-500 border border-gray-500';
        } else {
            buttonClass = `bg-white text-primary border ${color === 'primary' ? 'border-primary' : ''}`;
        }
    }

    buttonClass += ` ${fullWidth ? "w-full" : "w-auto"} py-2 px-5 rounded-md font-medium`;
    
    return(
        <>
            <button 
                className={buttonClass}
                onClick={onClick}
                disabled={disabled}
            >
                {label}
            </button>
        </>
    )
}

Button.propTypes = {
    label: PropTypes.string.isRequired,
    varient: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

Button.defaultProps = {
    label: " ",
    varient: "contained",
    disabled: false,
    fullWidth: true,
    color: "",
    onClick: () => {}
}

export default Button